import { combineReducers } from "redux"

import list from "./list/slice"
import removeFromGroup from "./removeFromGroup/slice"
import addToGroup from "./addToGroup/slice"

const groupsReducer = combineReducers({ list, removeFromGroup, addToGroup })

export default groupsReducer
